import { PieChart } from 'recharts'
import GaugeHalfPie from './gauge-half-pie'
import GaugeNeedle from './gauge-needle'

export interface GaugeChartData {
  // name of the section to be used to fix the needle with props currentName
  name: string
  // size of the section (relative to the other sections values)
  value: number
}

interface GaugeProps {
  chartData: GaugeChartData[]
  currentName: string
}

const Gauge = ({ chartData, currentName }: GaugeProps) => {
  // The first GaugeHalfPie display the pie chart and the second only the needle, see: https://recharts.github.io/en-US/examples/PieChartWithNeedle/
  return (
    <PieChart responsive className="mg-gauge" margin={{ top: 0, right: 0, bottom: 2, left: 0 }}>
      <GaugeHalfPie data={chartData} />
      <GaugeHalfPie data={chartData} shape={props => <GaugeNeedle {...props} currentName={currentName} />} />
    </PieChart>
  )
}

export default Gauge
